module.exports = __webpack_public_path__ + "img/couples-059.03f7ddbd.jpg";